import { render, staticRenderFns } from "./top-ten.vue?vue&type=template&id=97cd5440&"
import script from "./top-ten.vue?vue&type=script&lang=js&"
export * from "./top-ten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports